var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01068 15.7187C6.4552 15.4178 6.56157 14.8278 6.24827 14.4009C5.93497 13.9741 5.32064 13.8719 4.87612 14.1728L1.83485 16.2313C0.684316 17.01 0.73128 18.6629 1.92432 19.3802L12.4549 25.7117C13.0942 26.0961 13.9058 26.0961 14.5451 25.7117L25.0757 19.3802C26.2687 18.6629 26.3157 17.01 25.1652 16.2313L22.1239 14.1728C21.6794 13.8719 21.065 13.9741 20.7517 14.4009C20.4384 14.8278 20.5448 15.4178 20.9893 15.7187L24.0306 17.7772L13.5 24.1087L2.9694 17.7772L6.01068 15.7187Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.31605 8.15773L12.4219 1.68999C13.0791 1.26938 13.9209 1.26938 14.5781 1.68999L24.684 8.15773C25.2985 8.55107 25.2985 9.44893 24.684 9.84227L14.5781 16.31C13.9209 16.7306 13.0791 16.7306 12.4219 16.31L2.31605 9.84227C1.70145 9.44893 1.70145 8.55107 2.31605 8.15773Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDashboardIcon);
export default __webpack_public_path__ + "static/media/EmptyDashboardIcon.4e6f433438a9fff55f23781d102a189c.svg";
export { ForwardRef as ReactComponent };